import React from 'react';
import ReactECharts from 'echarts-for-react';

export const GraficoTortaMontos = ({ data = { conveniado: 0, adendas: 0 } }) => {

	// Formateador interno para los valores numéricos grandes
	const formatPesos = (valor) => {
		if (valor >= 1000000000) return `$${(valor / 1000000000).toFixed(2)}B`;
		if (valor >= 1000000) return `$${(valor / 1000000).toFixed(2)}M`;
		return `$${valor.toLocaleString('es-AR')}`;
	};

	// Estructuramos el formato esperado por el gráfico de torta de ECharts
	const chartData = [
		{ value: data.conveniado || 0, name: 'Monto Conveniado' },
		{ value: data.adendas || 0, name: 'Monto Adendas' }
	];

	const option = {
		// Colores: Azul institucional para el Convenio Base, Ámbar/Naranja para las Adendas (Alerta de desvío)
		color: ['#0284c7', '#f59e0b'],

		tooltip: {
			trigger: 'item',
			backgroundColor: '#1e293b',
			borderWidth: 0,
			textStyle: { color: '#ffffff', fontSize: 12 },
			padding: [10, 15],
			formatter: function (params) {
				return `<div style="font-weight: bold; margin-bottom: 4px; color: #94a3b8;">${params.seriesName}</div>
                        <div style="display: flex; justify-content: space-between; gap: 15px; align-items: center;">
                            <span>${params.marker} ${params.name}:</span>
                            <span style="font-weight: bold;">${formatPesos(params.value)} (${params.percent}%)</span>
                        </div>`;
			}
		},
		legend: {
			// 📋 MISMO FORMATO QUE PROYECTOS POR PROGRAMA: scroll vertical a la derecha con montos
			type: 'scroll',
			orient: 'vertical',
			right: '5%',
			top: 'center',
			itemGap: 12,
			textStyle: { color: '#4b5563', fontSize: 12 },
			formatter: function (name) {
				const encontrado = chartData.find(d => d.name === name);
				const cantidad = encontrado ? formatPesos(encontrado.value) : '0';
				return `${name} (${cantidad})`;
			}
		},
		series: [
        {
            name: 'Composición Financiera',
            type: 'pie',
            radius: ['40%', '70%'],
            center: ['30%', '50%'], // Desplazamos la torta a la izquierda para dar espacio a la leyenda
            avoidLabelOverlap: true, // Cambiado a true para evitar colisiones de texto
            minAngle: 15, // 🚀 TRUCO CLAVE: Le da al menos 15 grados a porciones diminutas para que se pinten sí o sí
            itemStyle: {
                borderRadius: 6,
                borderColor: '#ffffff',
                borderWidth: 2
            },
            label: {
                show: false, // Ocultamos las líneas con etiquetas externas (igual que Proyectos por Programa)
                position: 'center'
            },
            emphasis: {
                label: {
                    show: true,
                    fontSize: 16,
                    fontWeight: 'bold',
                    formatter: '{b}'
                }
            },
            labelLine: {
                show: false
            },
            // Asegurate de que los strings coincidan exactamente con la leyenda
            data: chartData
        }
    ]
	};

	return (
		<div className="bg-white p-6 rounded-xl border border-gray-200 shadow-sm h-[450px] flex flex-col">
			<div className="mb-2">
				<h3 className="text-base font-bold text-gray-800 tracking-tight uppercase">
					Relación Convenios vs Adendas
				</h3>
				<p className="text-xs text-gray-400">
					Impacto financiero del presupuesto original frente a modificaciones
				</p>
			</div>

			<div className="flex-1 w-full min-h-0">
				<ReactECharts
					option={option}
					style={{ height: '100%', width: '100%' }}
					notMerge={true}
				/>
			</div>
		</div>
	);
};